<template>
  <div class="managingPeople hp100 bbox" v-loading="loading">
    <!-- 卡片视图 -->
    <el-card>
      <!-- 搜索-->
      <el-row :gutter="20">
        <el-form :inline="true" :model="searchInput" style="padding-left:10px">
          <el-form-item label="">
            <!-- <el-button type="warning" icon="el-icon-delete"></el-button> -->
          </el-form-item>
          <el-form-item label="">
            <el-input placeholder="产品经理名称" clearable v-model="searchInput.businessDirectorName">
            </el-input>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="searchInput.accountTypeCode" clearable placeholder="请选择部门">
              <el-option v-for="item in branchList" :key="item.id" :label="item.accountTypeName"
                :value="item.accountTypeCode">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-button class="add-column-btn bbox" type="primary" @click="search">搜索</el-button>
          </el-form-item>
        </el-form>
      </el-row>
      <!-- 用户列表区域 -->
      <div>

        <el-table :data="tableData" border fit highlight-current-row style="width: 100%;margin-top:0;"
          @sort-change="sortChange" :height="height + 'px'">
          <el-table-column label="序号" align="center" prop="">
            <template slot-scope="scope">
              <span>{{ scope.row.id }}</span>
            </template>
          </el-table-column>
          <el-table-column label="商务负责人名称" align="center" prop="商务负责人名称">
            <template slot-scope="scope">
              <span>{{ scope.row.businessDirectorName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="跟进人名称" align="center" prop="跟进人名称">
            <template slot-scope="scope">
              <span>{{ scope.row.createName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="跟进时间" align="center" prop="跟进时间">
            <template slot-scope="scope">
              <span>{{ scope.row.createDt | dataFormat }}</span>
            </template>
          </el-table-column>
          <el-table-column label="客户姓名" align="center" prop="客户姓名">
            <template slot-scope="scope">
              <span>{{ scope.row.customerName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="跟进记录" align="center" prop="">
            <template slot-scope="scope">
              <span>{{ scope.row.content }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footerBox">
        <!-- 分页区域 -->
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" style="margin-top: 10px"
          :current-page.sync="queryInfo.currPage" :page-sizes="[100, 10, 20, 30, 50]" :page-size="queryInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      height: window.innerHeight - 230, //表格高度
      value: "",
      searchInput: {},
      tableData: [],
      loading: true,
      // 获取用户列表查询参数对象
      queryInfo: {
        // 当前页数
        currPage: 1,
        // 每页显示多少数据
        pageSize: 100,
        //查询条件
        condition: {
          id: "",
        },
      },
      userlist: [],
      total: 0,
      // 添加用户对话框
      addDialogVisible: false,
      // 用户添加
      addUserForm: {
        username: "",
        password: "",
        email: "",
        mobile: "",
      },
      // 修改用户
      editDialogVisible: false,
      editUserForm: {},
      // 分配角色对话框
      setRoleDialogVisible: false,
      branchList: [
        {
          value: '1',
          label: '云蓝'
        }
      ],
      branch: ""
    };
  },
  created() {
    // this.queryInfo.currPage = this.$route.query.currPage;
    // this.queryInfo.pageSize = this.$pageSize;
    this.getListData();
    window.addEventListener("resize", this.getHeight);
    this.getBranch()
    var that = this;
    document.onkeydown = function (e) {   //按下回车提交
      let key = window.event.keyCode;
      //事件中keycode=13为回车事件
      if (key == 13) {
        that.getListData();
      }
    };
  },
  mounted() {
    this.loading = false;
  },
  destroyed() {
    window.removeEventListener("resize", this.getHeight);
  },
  methods: {
    //条件查询
    search() {
      this.queryInfo.condition = this.searchInput;
      this.getListData();
    },
    // 监听 pagesize改变的事件
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;
      this.getListData();
    },
    // 监听 页码值 改变事件
    handleCurrentChange(newSize) {
      this.queryInfo.currPage = newSize;
      this.getListData();
    },

    // 监听排序
    sortChange() { },
    //跳转到详情
    gotoDetail(id) {
      var that = this;
      this.$router.push({
        path: "/customerFollowLog/details",
        query: {
          id: id,
          currPage: that.queryInfo.currPage,
          pageSize: that.queryInfo.pageSize,
        },
      });
    },

    // 删除用户
    async del(id) {
      const confirmResult = await this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).catch((err) => err);
      if (confirmResult === "confirm") {
        var that = this;
        that.$http
          .post("/customerFollowLog/delete", { id: id })
          .then(function (response) {
            that.$notify.success({
              title: "提示",
              message: "删除成功",
              showClose: true,
            });
            that.getListData();
          });
      }
    },
    getListData() {
      // 获取列表
      var that = this;
      that.queryInfo.condition.userCode = JSON.parse(localStorage.getItem("userCode")).value;
      that.$http
        .post("/customerFollowLog/list", that.queryInfo)
        .then(function (response) {
          console.log(response.data.data);
          if (response.data.code == 200) {
            that.total = response.data.data.count;
            that.queryInfo.currPage = response.data.data.currPage;
            that.tableData = response.data.data.data;
          }
        });
    },
    // 监听表格高度
    getHeight() {
      this.height = window.innerHeight - 256;
    },
    // 获取部门列表
    getBranch() {
      this.$http.post("/accountType/queryList", {}).then((res) => {
        console.log(res.data.data);
        if (res.data.code == 200) {
          this.branchList = res.data.data
        }
      });
    }
  },
};
</script>

<style lang="less" scoped>
.textblue {
  color: #008eff;
}

.managingPeople {

  .el-form-item--small.el-form-item {
    margin-bottom: 5px !important;
  }

  .el-card {
    height: calc(100vh - 114px);
    position: relative;

    /deep/.el-card__body {
      padding: 0 20px 10px 20px !important;
    }

    .el-select>.el-input {
      width: 200px;
    }

    .header-search-box .header-search-input {
      width: 325px;
    }

    input::placeholder {
      font-size: 12px;
    }

    .handle-btn .el-button.add-column-btn {
      width: 100%;
      font-size: 13px;
      background-color: transparent;
      color: #008eff;
      z-index: 102;
    }

    .footerBox {
      position: absolute;
      width: 100%;
      // height: 78px;
      left: 20px;
      right: 20px;
      bottom: 0;
    }
  }
}

/deep/.el-scrollbar__view {
  min-width: 100%;
}

/deep/.el-scrollbar__wrap {
  overflow-x: auto;
  height: calc(100%); //多出来的20px是横向滚动条默认的样式
  width: 100%;
}

/deep/.el-scrollbar .el-scrollbar__wrap .el-scrollbar__view {
  white-space: nowrap;
  display: inline-block;
}
</style>
